import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GetListPostCodeById,
  UpdatePostCode,
} from "../services/PostCodeService";
import { useDispatch } from "react-redux";
import { setErrorMessage, setSuccessMessage } from "../slices/messageSlice";
import * as XLSX from "xlsx";
import PostCodesTable from "../components/PostCodesTable";
const DetailPostCodes = () => {
  const { id } = useParams();
  const [postCodes, setPostCodes] = useState(null);
  
  const dispatch = useDispatch();
  const fetchData = async () => {
    const response = await GetListPostCodeById(id);
    if (response.status_code == 200) {
      setPostCodes(response.data);
    } else {
      dispatch(setErrorMessage(response.message));
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      const formattedData = jsonData.map(
        (item) => `${item.postDate}-${item.postCode}`
      );
      const joinedData = formattedData.join(";;");
      const response = await UpdatePostCode(
        id,
        joinedData,
        postCodes?.active,
        postCodes?.isCurrentUsed
      );
      if (response.status_code == 200) {
        fetchData();
        dispatch(setSuccessMessage("Thay đổi danh sách mã thành công"));
      } else {
        dispatch(setErrorMessage(response.message));
      }
    };
    reader.readAsArrayBuffer(file);
  };
  return (
    <div className="pt-10 h-full min-h-screen flex justify-center overflow-y-auto p-16 bg-white text-black dark:bg-gray-900 dark:text-white">
      <div className="w-[1400px] bg-white rounded dark:bg-gray-800 shadow-lg p-6">
        <div className="max-w-[720px] mx-auto mt-10">
          <h1 className="text-3xl font-semibold mb-6">
            CHI TIẾT BỘ MÃ BÀI ĐĂNG
          </h1>
        </div>
        <div className="flex flex-row items-center justify-end pr-10 space-x-8">
          <button
            className="text-sm text-gray-500 py-2 px-4 border-0 font-semibold bg-blue-500  hover:bg-blue-600 dark:bg-blue-700 dark:text-white dark:hover:bg-blue-800"
            onClick={() => document.getElementById("fileInput").click()}
          >
            Đổi Bộ Mã
          </button>
          <input
            id="fileInput"
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            className="hidden"
          />
        </div>
       <div className="pt-8">
            {postCodes ? (
              <PostCodesTable postCode={postCodes} reload={fetchData} />
            ) : (
              <div className="flex w-full justify-center flex-col items-center py-10">
                <svg
                  aria-hidden="true"
                  className="inline w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-green-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <h2>Đang Tải...</h2>
              </div>
            )}
       </div>
      </div>
    </div>
  );
};

export default DetailPostCodes;
